import { useContext } from "react";
import { LocaleContext } from "../app";
import { Link } from "react-router";

export function NextStatements({ content }) {
  const { translate } = useContext(LocaleContext);

  if (content.settings.availableStatements.length === 0) {
    return (
      <a href={translate("next.more_info_url")} className="link">
        {translate("next.more_info")}
      </a>
    );
  }

  return (
    <>
      {content.settings.availableStatements.map((key) => (
        <Link to={`../${key}`} key={key} className="link-card">
          {translate(["statements", key, "shortName"])}
        </Link>
      ))}

      <a href={translate("next.more_info_url")} className="link">
        {translate("next.more_info")}
      </a>
    </>
  );
}
